define('plugins/musicfavourite/nls/sounds/dialog',{
    'en-gb': {
        'upsell': {
            'heading': 'Sign in to add this to My Music',
            'text': 'Use My Music to keep track of the acts you love.',
            'signIn': 'Sign in',
            'signInText1': ' with your BBC iD',
            'signInText2': 'or',
            'signInText3': 'Register',
            'signInText4': 'It&rsquo;s fast and free.'
        },
        'limited': {
            'heading': 'Sorry, you’ve reached the limit'
        }
    },
    'cy-gb': { //WELSH
        'upsell': {
            'heading': 'Sign in to add this to My Music',
            'text': 'Use My Music to keep track of the acts you love.',
            'signIn': 'Mewngofnodwch',
            'signInText1': 'gyda&rsqo;ch BBC iD',
            'signInText2': 'neu',
            'signInText3': 'Gofrestrwch',
            'signInText4': 'Mae&rsquo;n gyflym ac yn rhad.'
        }
    },
    'ga-gb': { //IRISH
        'upsell': {
            'heading': 'Sign in to add this to My Music',
            'text': 'Use My Music to keep track of the acts you love.',
            'signIn': 'S&iacute;nigh isteach',
            'signInText1': ' ag baint &uacute;s&aacute;ide as do BBC iD',
            'signInText2': 'n&oacute;',
            'signInText3': 'Cl&aacute;raigh',
            'signInText4': 'T&aacute; s&eacute; simpl&iacute; agus saor.'
        }
    },
    'gd-gb': { //SCOTTISH
        'upsell': {
            'heading': 'Sign in to add this to My Music',
            'text': 'Use My Music to keep track of the acts you love.',
            'signIn': 'Log a-steach',
            'signInText1': ' le BBC iD',
            'signInText2': 'no',
            'signInText3': 'Cl&agrave;raich',
            'signInText4': 'Tha e luath is saor agus an asgaidh.'
        }
    }
});

